import { render } from "./CalendarContainerVue.vue?vue&type=template&id=2bba0a1e"
import script from "./CalendarContainerVue.vue?vue&type=script&lang=js"
export * from "./CalendarContainerVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LCE\\Documents\\code\\front-end LCE\\prudentialBelife\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__